var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-app', {
    attrs: {
      "id": "inspire"
    }
  }, [_c('main-menu', {
    staticStyle: {
      "padding-top": "60px"
    },
    attrs: {
      "drawer-prop": _vm.drawer
    }
  }), _c('v-toolbar', {
    staticStyle: {
      "height": "60px",
      "z-index": "7"
    },
    attrs: {
      "color": "primary",
      "dark": "",
      "fixed": "",
      "app": "",
      "height": "60",
      "pl-1": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "/img/atlas-mobile.png",
      "alt": "avatar"
    }
  }), _c('v-spacer'), _c('v-toolbar-side-icon', {
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer;
      }
    }
  })], 1), _c('v-content', [_c('v-container', {
    attrs: {
      "fluid": "",
      "pa-0": ""
    }
  }, [_c('router-view', {
    key: _vm.$route.fullPath
  })], 1)], 1), _c('v-footer', {
    attrs: {
      "color": !_vm.isOnline ? 'red  darken-4' : 'primary',
      "app": ""
    }
  }, [_c('span', {
    staticClass: "white--text caption px-2"
  }, [_vm._v("© " + _vm._s(new Date().getFullYear()) + "\n      " + _vm._s(_vm.$vuetify.t('$vuetify.app.copyright')))]), _c('v-spacer'), _c('span', {
    staticClass: "white--text caption px-2"
  }, [_vm._v(_vm._s(_vm.version))]), _vm.isOnline ? _c('v-icon', {
    attrs: {
      "dark": ""
    },
    on: {
      "click": function click($event) {
        return _vm.reloadApp();
      }
    }
  }, [_vm._v("refresh")]) : _c('v-icon', {
    staticStyle: {
      "width": "30px"
    },
    attrs: {
      "dark": ""
    }
  }, [_vm._v("wifi_off")])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }